/* Dress Collar — Signature colorway drum.
   Photo-card mode default (per CHANGE-drum-photo-cards.md).
   - 3D coverflow with rAF-driven inline transforms (no CSS transitions)
   - Drag + inertia + snap, arrows, swatch dots, keyboard, idle auto-rotate
   - IntersectionObserver pauses the loop when off-screen
   - Reduced-motion → horizontal snap-scroller fallback only
*/
(function () {
  'use strict';
  var root = document.querySelector('[data-dc-drum]');
  if (!root) return;
  var stage = root.querySelector('.dc-drum-stage');
  var track = root.querySelector('.dc-drum-track');
  var items = Array.prototype.slice.call(track ? track.querySelectorAll('.dc-drum-item') : []);
  if (!stage || !track || !items.length) return;

  var N = items.length;
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Mode-aware geometry. Card mode default, cutout fallback values preserved.
  var mode = root.dataset.mode || 'card';
  var G = (mode === 'card')
    ? { GAP1: 0.78, GAP2: 0.52, GAP3: 0.32, ANGLE: 34, DEPTH: 110, SCSTEP: 0.15, MINSC: 0.46 }
    : { GAP1: 0.62, GAP2: 0.42, GAP3: 0.26, ANGLE: 44, DEPTH: 130, SCSTEP: 0.16, MINSC: 0.42 };

  var itemW = 320;
  function measure() { itemW = items[0].offsetWidth || 320; }

  var nameEl = root.querySelector('[data-dc-drum-name]');
  var familyEl = root.querySelector('[data-dc-drum-family]');
  var priceEl = root.querySelector('[data-dc-drum-price]');
  var linkEl = root.querySelector('[data-dc-drum-link]');
  var tintEl = root.querySelector('.dc-drum-tint');
  var dotsEl = root.querySelector('[data-dc-drum-dots]');
  var hintEl = root.querySelector('.dc-drum-hint');
  var prevBtn = root.querySelector('.dc-prev');
  var nextBtn = root.querySelector('.dc-next');

  // Build dots
  if (dotsEl) {
    items.forEach(function (el, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.style.background = el.dataset.swatch || '#CCC';
      if (el.hasAttribute('data-light')) b.setAttribute('data-light', '');
      b.setAttribute('aria-label', el.dataset.name || '');
      b.title = el.dataset.name || '';
      b.addEventListener('click', function () { goTo(i); poke(); });
      dotsEl.appendChild(b);
    });
  }
  var dots = dotsEl ? Array.prototype.slice.call(dotsEl.children) : [];

  // State
  var pos = 0, vel = 0, goal = null, dragging = false, raf = 0, paused = true;
  var active = -1;
  var lastInteract = Date.now();
  var lastMove = 0;

  function mod(k) { return ((k % N) + N) % N; }
  function ringOffset(i) {
    var o = i - pos;
    o = ((o % N) + N) % N;
    if (o > N / 2) o -= N;
    return o;
  }

  function styleFor(o) {
    var a = Math.abs(o), sgn = Math.sign(o);
    var x = sgn * (Math.min(a, 1) * G.GAP1 + Math.max(0, Math.min(a, 3) - 1) * G.GAP2 + Math.max(0, a - 3) * G.GAP3) * itemW;
    var ry = -Math.max(-3, Math.min(3, o)) * G.ANGLE;
    var z = -a * G.DEPTH;
    var sc = Math.max(G.MINSC, 1 - a * G.SCSTEP);
    var op = 1;
    if (a > 2.7) op = Math.max(0, (3.5 - a) / 0.8);
    var zi = 1000 - Math.round(a * 12);
    return { x: x, ry: ry, z: z, sc: sc, op: op, zi: zi };
  }

  function layout() {
    for (var i = 0; i < N; i++) {
      var o = ringOffset(i);
      var s = styleFor(o);
      var el = items[i];
      el.style.transform = 'translate3d(' + s.x.toFixed(1) + 'px,0,' + s.z.toFixed(1) + 'px) rotateY(' + s.ry.toFixed(2) + 'deg) scale(' + s.sc.toFixed(3) + ')';
      el.style.opacity = s.op.toFixed(2);
      el.style.zIndex = s.zi;
      var isActive = (mod(Math.round(pos)) === i);
      el.classList.toggle('dc-is-active', isActive);
    }
  }

  function setActive(i) {
    if (i === active) return;
    active = i;
    var el = items[i];
    if (!el) return;
    if (nameEl) nameEl.textContent = el.dataset.name || '';
    if (familyEl) familyEl.textContent = el.dataset.family || '';
    if (priceEl && root.dataset.fromPrice) priceEl.textContent = root.dataset.fromPrice;
    if (linkEl) linkEl.href = el.dataset.url || '#';
    if (tintEl && el.dataset.swatch) tintEl.style.setProperty('--dc-tint', el.dataset.swatch);
    dots.forEach(function (d, k) { d.classList.toggle('dc-on', k === i); });
    try { if (navigator.vibrate) navigator.vibrate(8); } catch (e) {}
    try { localStorage.setItem('dc_pdp_color', el.dataset.name || ''); } catch (e) {}
  }

  function frame() {
    if (paused) { raf = requestAnimationFrame(frame); return; }
    if (!dragging) {
      if (goal !== null) {
        pos += (goal - pos) * 0.16;
        if (Math.abs(goal - pos) < 0.0009) { pos = goal; goal = null; }
      } else if (Math.abs(vel) > 0.018) {
        pos += vel; vel *= 0.90;
      } else if (vel !== 0) {
        vel = 0; goal = Math.round(pos);
      }
    }
    layout();
    // Sync caption + active dot to whichever card is visually centered RIGHT NOW.
    // setActive short-circuits when the index hasn't changed, so this is cheap.
    setActive(mod(Math.round(pos)));
    raf = requestAnimationFrame(frame);
  }

  function goTo(i) {
    var base = Math.round(pos);
    var best = i, bestD = Infinity;
    for (var k = -1; k <= 1; k++) {
      var cand = Math.round((base - i) / N + k) * N + i;
      var d = Math.abs(cand - pos);
      if (d < bestD) { bestD = d; best = cand; }
    }
    vel = 0; goal = best;
  }
  function step(dir) { vel = 0; goal = (goal !== null ? Math.round(goal) : Math.round(pos)) + dir; }
  function poke() { lastInteract = Date.now(); if (hintEl) hintEl.style.opacity = '0'; }

  // Drag
  var startX = 0, startPos = 0, lastX = 0;
  function down(e) {
    if (e.button != null && e.button !== 0) return;
    dragging = true; vel = 0; goal = null;
    startX = e.clientX != null ? e.clientX : (e.touches ? e.touches[0].clientX : 0);
    startPos = pos; lastX = startX; lastMove = 0;
    poke();
    try { stage.setPointerCapture && e.pointerId != null && stage.setPointerCapture(e.pointerId); } catch (err) {}
  }
  function move(e) {
    if (!dragging) return;
    var x = e.clientX != null ? e.clientX : (e.touches ? e.touches[0].clientX : 0);
    var dx = x - startX;
    pos = startPos - dx / (itemW * 0.62);
    lastMove = (x - lastX); lastX = x;
    poke();
  }
  function up() {
    if (!dragging) return;
    dragging = false;
    vel = -lastMove / (itemW * 0.62) * 0.9;
    if (Math.abs(vel) < 0.02) { vel = 0; goal = Math.round(pos); }
    poke();
  }
  stage.addEventListener('pointerdown', down);
  window.addEventListener('pointermove', move, { passive: true });
  window.addEventListener('pointerup', up);

  // Click center polo → that product URL
  track.addEventListener('click', function (e) {
    var it = e.target.closest && e.target.closest('.dc-drum-item');
    if (!it) return;
    if (Math.abs(lastMove) > 2) return;
    var i = parseInt(it.dataset.index, 10);
    if (mod(Math.round(pos)) === i) {
      var url = it.dataset.url; if (url) window.location.href = url;
    } else { goTo(i); poke(); }
  });

  if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); poke(); });
  if (nextBtn) nextBtn.addEventListener('click', function () { step(1); poke(); });

  // Keyboard
  stage.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); poke(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); poke(); }
    else if (e.key === 'Enter') {
      var el = items[mod(Math.round(pos))];
      if (el && el.dataset.url) window.location.href = el.dataset.url;
    }
  });

  // Idle auto-rotation
  setInterval(function () {
    if (prefersReduced || paused) return;
    if (!dragging && goal === null && vel === 0 && Date.now() - lastInteract > 4000) step(1);
  }, 2600);

  // IntersectionObserver — pause rAF when off-screen
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { paused = !entry.isIntersecting; });
    }, { threshold: 0.05 });
    io.observe(root);
  } else {
    paused = false;
  }

  // Init
  function init() {
    if (prefersReduced) {
      // CSS hides .dc-drum-stage and friends; fallback list is already SSR'd.
      // We still need to set active info to the first item for the head text.
      setActive(0);
      return;
    }
    measure();
    // Try to start on Navy if present
    var navyIdx = -1;
    items.forEach(function (el, i) { if (/navy/i.test(el.dataset.name || '')) navyIdx = i; });
    pos = navyIdx >= 0 ? navyIdx : 0; goal = null;
    setActive(mod(Math.round(pos)));
    layout();
    paused = false;
    raf = requestAnimationFrame(frame);
    window.addEventListener('resize', function () { measure(); layout(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
